var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIndiaFlag(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 26,
    viewBox: "0 0 37 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.02043 0H34.9796C36.0937 0.00608329 37 0.927702 37 2.05311V23.9469C37 25.0753 36.0846 26 34.9675 26H2.02043C0.909342 25.9939 0 25.0723 0 23.9469V2.05311C0 0.927702 0.906331 0.00608329 2.02043 0Z",
    fill: "#FF9933"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 8.66577H37V17.3345H0V8.66577Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 17.3342H37V23.9468C37 25.0752 36.0846 25.9999 34.9675 25.9999H2.02043C0.909342 25.9938 0 25.0722 0 23.9468V17.3342Z",
    fill: "#128807"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9326 12.9999C21.9326 11.0837 20.397 9.53247 18.5 9.53247C16.603 9.53247 15.0674 11.0837 15.0674 12.9999C15.0674 14.9131 16.603 16.4674 18.5 16.4674C20.397 16.4674 21.9326 14.9162 21.9326 12.9999Z",
    fill: "#000088"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.502 13.0001C21.502 11.3241 20.1591 9.96753 18.5 9.96753C16.8409 9.96753 15.498 11.3241 15.498 13.0001C15.498 14.676 16.8409 16.0326 18.5 16.0326C20.1591 16.0326 21.502 14.676 21.502 13.0001Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0992 12.9999C19.0992 12.6653 18.8312 12.3916 18.5 12.3916C18.1688 12.3916 17.9008 12.6623 17.9008 12.9999C17.9008 13.3345 18.1688 13.6052 18.5 13.6052C18.8312 13.6052 19.0992 13.3345 19.0992 12.9999Z",
    fill: "#000088"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6255 13.4168C21.6375 13.3346 21.5773 13.2586 21.496 13.2464C21.4147 13.2343 21.3394 13.2951 21.3274 13.3772C21.3154 13.4593 21.3756 13.5354 21.4569 13.5475C21.5412 13.5567 21.6165 13.4989 21.6255 13.4168Z",
    fill: "#000088"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 16.0325L18.6024 14.2135L18.5 13.3467L18.3976 14.2135L18.5 16.0325Z",
    fill: "#000088"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4117 14.2197C21.4448 14.1437 21.4057 14.0524 21.3304 14.022C21.2551 13.9885 21.1648 14.0281 21.1347 14.1041C21.1016 14.1802 21.1407 14.2714 21.216 14.3018C21.2943 14.3322 21.3816 14.2957 21.4117 14.2197Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7231 15.929L18.2892 14.1983L18.4127 13.3345L18.0905 14.1466L17.7231 15.929Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0022 14.9405C21.0534 14.8736 21.0413 14.7793 20.9751 14.7276C20.9088 14.6759 20.8155 14.688 20.7643 14.755C20.7131 14.8219 20.7252 14.9162 20.7914 14.9679C20.8577 15.0196 20.951 15.0044 21.0022 14.9405Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9975 15.6279L17.9881 14.104L18.3284 13.301L17.8105 13.9976L16.9975 15.6279Z",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4181 15.5277C20.4843 15.476 20.4963 15.3817 20.4452 15.3148C20.394 15.2479 20.3006 15.2357 20.2344 15.2874C20.1681 15.3391 20.1561 15.4334 20.2073 15.5003C20.2585 15.5642 20.3548 15.5794 20.4181 15.5277Z",
    fill: "black"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3772 15.1443L17.7231 13.9307L18.2561 13.2463L17.5786 13.7847L16.3772 15.1443Z",
    fill: "black"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7074 15.9442C19.7827 15.9107 19.8219 15.8225 19.7887 15.7465C19.7556 15.6704 19.6683 15.6309 19.593 15.6643C19.5177 15.6947 19.4786 15.786 19.5117 15.862C19.5418 15.9381 19.6291 15.9746 19.7074 15.9442Z",
    fill: "black"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8984 14.5177L17.5124 13.6965L18.2019 13.1733L17.407 13.517L15.8984 14.5177Z",
    fill: "black"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9125 16.1573C18.9938 16.1451 19.051 16.0691 19.042 15.987C19.0299 15.9048 18.9547 15.847 18.8734 15.8562C18.7921 15.8683 18.7349 15.9444 18.7439 16.0265C18.7529 16.1117 18.8282 16.1695 18.9125 16.1573Z",
    fill: "black"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6003 13.7848L17.3678 13.4137L18.1688 13.0913L17.3136 13.213L15.6003 13.7848Z",
    fill: "black"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0875 16.1572C18.1688 16.1693 18.2441 16.1085 18.2561 16.0264C18.2681 15.9443 18.2079 15.8682 18.1266 15.856C18.0453 15.8439 17.97 15.9047 17.958 15.9868C17.949 16.072 18.0062 16.148 18.0875 16.1572Z",
    fill: "black"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M15.498 13.0001L17.2986 13.1036L18.1567 13.0001L17.2986 12.8967L15.498 13.0001Z",
    fill: "black"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2926 15.9442C17.3678 15.9776 17.4582 15.9381 17.4883 15.862C17.5184 15.786 17.4823 15.6947 17.407 15.6643C17.3317 15.6309 17.2414 15.6704 17.2113 15.7465C17.1811 15.8225 17.2173 15.9107 17.2926 15.9442Z",
    fill: "black"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6003 12.2153L17.3136 12.7872L18.1688 12.9119L17.3678 12.5864L15.6003 12.2153Z",
    fill: "black"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M16.579 15.5277C16.6452 15.5794 16.7385 15.5672 16.7897 15.5003C16.8409 15.4334 16.8289 15.3391 16.7626 15.2874C16.6964 15.2357 16.603 15.2479 16.5519 15.3148C16.5037 15.3817 16.5157 15.476 16.579 15.5277Z",
    fill: "black"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8984 11.4822L17.407 12.4829L18.2019 12.8266L17.5124 12.3034L15.8984 11.4822Z",
    fill: "black"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9978 14.9405C16.049 15.0074 16.1423 15.0196 16.2086 14.9679C16.2748 14.9162 16.2869 14.8219 16.2357 14.755C16.1845 14.688 16.0912 14.6759 16.0249 14.7276C15.9617 14.7762 15.9466 14.8736 15.9978 14.9405Z",
    fill: "black"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3772 10.8557L17.5786 12.2153L18.2561 12.7567L17.7231 12.0693L16.3772 10.8557Z",
    fill: "black"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5853 14.2197C15.6184 14.2957 15.7057 14.3353 15.781 14.3018C15.8563 14.2684 15.8954 14.1802 15.8623 14.1041C15.8292 14.0281 15.7419 13.9885 15.6666 14.022C15.5913 14.0524 15.5552 14.1406 15.5853 14.2197Z",
    fill: "black"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9975 10.3721L17.8105 12.0024L18.3284 12.6989L17.9881 11.899L16.9975 10.3721Z",
    fill: "black"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3745 13.4166C15.3866 13.4988 15.4618 13.5566 15.5431 13.5474C15.6244 13.5353 15.6817 13.4592 15.6726 13.3771C15.6606 13.295 15.5853 13.2372 15.504 13.2463C15.4197 13.2554 15.3625 13.3315 15.3745 13.4166Z",
    fill: "black"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7231 10.0708L18.0905 11.8562L18.4127 12.6653L18.2892 11.8015L17.7231 10.0708Z",
    fill: "black"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3745 12.5834C15.3625 12.6655 15.4227 12.7416 15.504 12.7537C15.5853 12.7659 15.6606 12.7051 15.6726 12.6229C15.6847 12.5408 15.6244 12.4648 15.5431 12.4526C15.4588 12.4435 15.3836 12.5013 15.3745 12.5834Z",
    fill: "black"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 9.96753L18.3976 11.7864L18.5 12.6533L18.6024 11.7864L18.5 9.96753Z",
    fill: "black"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5883 11.7803C15.5552 11.8564 15.5943 11.9476 15.6696 11.978C15.7449 12.0085 15.8352 11.972 15.8653 11.8959C15.8985 11.8199 15.8593 11.7286 15.784 11.6982C15.7057 11.6678 15.6184 11.7043 15.5883 11.7803Z",
    fill: "black"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2769 10.0708L18.7108 11.8015L18.5873 12.6653L18.9095 11.8562L19.2769 10.0708Z",
    fill: "black"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9978 11.0623C15.9466 11.1292 15.9587 11.2235 16.0249 11.2752C16.0911 11.327 16.1845 11.3148 16.2357 11.2479C16.2869 11.181 16.2748 11.0867 16.2086 11.035C16.1423 10.9832 16.049 10.9954 15.9978 11.0623Z",
    fill: "black"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0025 10.3721L19.0119 11.899L18.6716 12.6989L19.1895 12.0024L20.0025 10.3721Z",
    fill: "black"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5819 10.4724C16.5157 10.5241 16.5036 10.6184 16.5548 10.6853C16.606 10.7522 16.6994 10.7644 16.7656 10.7127C16.8319 10.661 16.8439 10.5667 16.7927 10.4998C16.7415 10.4328 16.6452 10.4237 16.5819 10.4724Z",
    fill: "black"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6228 10.8557L19.2769 12.0693L18.7439 12.7567L19.4214 12.2153L20.6228 10.8557Z",
    fill: "black"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2926 10.0588C17.2173 10.0922 17.1811 10.1805 17.2113 10.2565C17.2444 10.3325 17.3317 10.3721 17.407 10.3386C17.4823 10.3052 17.5214 10.217 17.4883 10.1409C17.4582 10.0618 17.3708 10.0253 17.2926 10.0588Z",
    fill: "black"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1016 11.4822L19.4876 12.3034L18.7981 12.8266L19.593 12.4829L21.1016 11.4822Z",
    fill: "black"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0875 9.84262C18.0062 9.85478 17.949 9.93082 17.958 10.0129C17.97 10.0951 18.0453 10.1529 18.1266 10.1437C18.2079 10.1316 18.2681 10.0555 18.2561 9.97341C18.2471 9.89128 18.1718 9.83045 18.0875 9.84262Z",
    fill: "black"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3996 12.2153L19.6321 12.5864L18.8312 12.9119L19.6863 12.7872L21.3996 12.2153Z",
    fill: "black"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9125 9.84262C18.8312 9.83045 18.756 9.89128 18.7439 9.97341C18.7319 10.0555 18.7921 10.1316 18.8734 10.1437C18.9547 10.1559 19.03 10.0951 19.042 10.0129C19.051 9.93082 18.9938 9.85174 18.9125 9.84262Z",
    fill: "black"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M21.502 13.0001L19.7014 12.8967L18.8433 13.0001L19.7014 13.1036L21.502 13.0001Z",
    fill: "black"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7074 10.0589C19.6322 10.0254 19.5418 10.0649 19.5117 10.141C19.4786 10.217 19.5177 10.3083 19.593 10.3387C19.6683 10.3691 19.7586 10.3326 19.7887 10.2566C19.8188 10.1775 19.7827 10.0893 19.7074 10.0589Z",
    fill: "black"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3996 13.7848L19.6863 13.213L18.8312 13.0913L19.6321 13.4137L21.3996 13.7848Z",
    fill: "black"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4181 10.4725C20.3518 10.4207 20.2585 10.4329 20.2073 10.4998C20.1561 10.5667 20.1681 10.661 20.2344 10.7127C20.3006 10.7645 20.394 10.7523 20.4452 10.6854C20.4963 10.6185 20.4843 10.5242 20.4181 10.4725Z",
    fill: "black"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1016 14.5177L19.593 13.517L18.7981 13.1733L19.4876 13.6965L21.1016 14.5177Z",
    fill: "black"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0022 11.0623C20.951 10.9954 20.8577 10.9832 20.7914 11.035C20.7252 11.0867 20.7131 11.181 20.7643 11.2479C20.8155 11.3148 20.9088 11.327 20.9751 11.2752C21.0383 11.2235 21.0534 11.1262 21.0022 11.0623Z",
    fill: "black"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6228 15.1443L19.4214 13.7847L18.7439 13.2463L19.2769 13.9307L20.6228 15.1443Z",
    fill: "black"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4147 11.7801C21.3816 11.7041 21.2943 11.6646 21.219 11.698C21.1437 11.7315 21.1046 11.8197 21.1377 11.8957C21.1708 11.9718 21.2581 12.0083 21.3334 11.9778C21.4087 11.9474 21.4448 11.8592 21.4147 11.7801Z",
    fill: "black"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0025 15.6279L19.1895 13.9976L18.6716 13.301L19.0119 14.104L20.0025 15.6279Z",
    fill: "black"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6255 12.5834C21.6134 12.5013 21.5382 12.4435 21.4569 12.4526C21.3756 12.4648 21.3184 12.5408 21.3274 12.6229C21.3394 12.7051 21.4147 12.7629 21.496 12.7537C21.5803 12.7446 21.6375 12.6686 21.6255 12.5834Z",
    fill: "black"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2769 15.929L18.9095 14.1466L18.5873 13.3345L18.7108 14.1983L19.2769 15.929Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndiaFlag);
export default __webpack_public_path__ + "static/media/indiaFlag.e16ffc836607df951ca02cb7ff2ffb97.svg";
export { ForwardRef as ReactComponent };